import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';
import { useSelector } from 'react-redux';
import { fromOrder } from '../../../../store';
import { PriceRows } from './PriceRows';
import { formatCurrency } from '../../../../components';
import { DEFAULT_CURRENCY_FORMAT_OPTIONS } from '../../../../utils/Constants';
import { useLaunchDarkly } from '../../../../launchdarkly';
import {
  buildPreviewProducts,
  getTrueBundlePreviewRequests,
} from './trueBundlePreview';

const useStyles = makeStyles(theme => ({
  totalRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 0),
  },
  totalLabel: {
    fontWeight: 700,
    fontSize: 15,
    color: '#22283c',
  },
  totalAmount: {
    fontWeight: 800,
    fontSize: 24,
    color: '#0F8461',
  },
}));

export const PriceSummary = (
  { isAnnual }: {
    isAnnual: boolean;
  },
) => {
  const classes = useStyles();
  const intl = useIntl();
  const { flags } = useLaunchDarkly();
  const orderPreviewResponse = useSelector(fromOrder.selectOrderPreviewResponse);
  const orderPreviewRequest = useSelector(fromOrder.selectOrderPreviewRequest);
  const fallbackPreviewRequest = useSelector(fromOrder.selectTruePlatformPreviewRequest);
  const previewRequests = getTrueBundlePreviewRequests(
    orderPreviewRequest,
    fallbackPreviewRequest,
  );
  const productsPreview = buildPreviewProducts(
    previewRequests,
    orderPreviewResponse,
    flags?.subscriptionPlanPrice,
  );
  const displayTotal = productsPreview.reduce((total, product) => total + product.total, 0);

  return (
    <Box
      id="price-summary"
      display="flex"
      flexDirection="column"
    >
      <Typography variant="h4" fontWeight={600} lineHeight="135%">
        <FormattedMessage id="page.plan.v2.plan.price.details.title" />
      </Typography>
      {productsPreview.map(productPreview => (
        <Box key={productPreview.productCode}>
          <PriceRows
            isAnnual={isAnnual}
            productsPreview={productPreview}
          />
        </Box>
      ))}

      {/* Annual total */}
      <Box className={classes.totalRow}>
        <Typography className={classes.totalLabel}>
          <FormattedMessage
            id="page.plan.v2.total"
          />
        </Typography>
        <Typography className={classes.totalAmount}>
          {formatCurrency(intl, displayTotal, DEFAULT_CURRENCY_FORMAT_OPTIONS)}
        </Typography>
      </Box>
    </Box>
  );
};
